export const isContainingTag = (tagList, tag) =>
  tagList.some(tagItem => {
    if (typeof tag === 'string') {
      if (tagItem.id || tag) {
        return tag === tagItem.id;
      }
    }

    const { id, orgId, streamId, channelId, value } = tag;
    // compare by id
    if (tagItem.id || id) {
      return id === tagItem.id;
    }

    // compare by orgId, streamId, channelId and value
    return (
      orgId === tagItem.orgId &&
      streamId === tagItem.streamId &&
      channelId === tagItem.channelId &&
      value === tagItem.value
    );
  });
